export const LOCATION = {
  W: 'W',
  P: 'P',
  C: 'C',
  S: 'S'
} as const;

export type Location = (typeof LOCATION)[keyof typeof LOCATION];

export const LOCATION_TITLES = {
  W: 'Warehouse',
  P: 'Port',
  C: 'Customer',
  S: 'Site'
} as const;

export type LocationTitles = (typeof LOCATION_TITLES)[keyof typeof LOCATION_TITLES];

export type LocationTypeFilter = Record<Location, boolean>;
export type FilteredLocationCounts = Record<Location, number>;
